module.exports = __webpack_public_path__ + "img/print-complete-v1.0b0623b9.png";